import { render, staticRenderFns } from "./ColorInput.vue?vue&type=template&id=39513c1c&scoped=true&"
import script from "./ColorInput.vue?vue&type=script&lang=js&"
export * from "./ColorInput.vue?vue&type=script&lang=js&"
import style0 from "./ColorInput.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./ColorInput.vue?vue&type=style&index=1&id=39513c1c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39513c1c",
  null
  
)

export default component.exports